module.exports = __webpack_public_path__ + "static/media/18ECA6.8c3c8e4d.jpg";